<ng-container
  *ngIf="{
    mouseMove: mouseMove$ | async,
    isLatLonShow: isLatLonShow$ | async,
    zoom: zoomLevel$ | async
  } as c"
>
  <div class="modus-footer d-flex flex-row-reverse overflow-auto footer">
    <div class="small text-gray-4">
      © Copyright {{ currentYear }}, Trimble Inc.
      <span class="border-left pl-1" *ngIf="!fullScreenView">
        <a routerLink="/terms">Terms of Use </a>
      </span>
      <span class="border-left pl-1" *ngIf="!fullScreenView">
        <a href="http://support.pcmilerweb.com" target="_blank">
          Contact Support
        </a>
      </span>
    </div>
    <div class="mousePosition small" *ngIf="c?.isLatLonShow && c?.mouseMove">
      <!-- to limit the lng and lng info to 6 decimal digit -->
      <strong>Lat:</strong>&nbsp;{{
        c?.mouseMove?.lngLat?.lat | number : "1.6-6"
      }}&nbsp;&nbsp;<strong>Lon:</strong>&nbsp;{{
        c?.mouseMove?.lngLat?.lng | number : "1.6-6"
      }}&nbsp;&nbsp;|&nbsp;&nbsp;<strong>Zoom:</strong>&nbsp;{{ c?.zoom }}
    </div>
    <div class="small text-gray-4">
      <span *ngIf="currentUser">
        {{ currentUser.userName }} ({{ currentUser.roles[0] }}),
        {{ currentUser.account }}
      </span>
    </div>
  </div>
</ng-container>
